<template>
  <section class="feed-page">
    <div class="feed-section" v-if="weatherItem">
      <FeedWeatherWidget :item="weatherItem" />
    </div>

    <!-- <div class="feed-section" v-if="showHalykBanner">
      <FeedBannerCard />
    </div> -->

    <div class="feed-section" v-for="item in quizItems" :key="`quiz-${item.id}`">
      <FeedQuizCard :item="item" />
    </div>

    <div class="feed-section" v-for="item in profiwayItems" :key="`profiway-${item.id}`">
      <FeedProfiwayCard :item="item" />
    </div>

    <div class="feed-news-grid" v-if="newsItems.length">
      <FeedNewsCard v-for="item in newsItems" :key="`news-${item.id}`" :item="item" />
    </div>
  </section>
</template>

<script setup>
import { computed, onMounted } from "vue";
import { useI18n } from "vue-i18n";

import FeedBannerCard from "@/components/feed/FeedBannerCard.vue";
import FeedNewsCard from "@/components/feed/FeedNewsCard.vue";
import FeedProfiwayCard from "@/components/feed/FeedProfiwayCard.vue";
import FeedQuizCard from "@/components/feed/FeedQuizCard.vue";
import FeedWeatherWidget from "@/components/feed/FeedWeatherWidget.vue";
import {
  useFeedNewsListQuery,
  useFeedProfiwayListQuery,
  useFeedQuizListQuery,
  useFeedWeatherQuery,
} from "@/queries";
import { useTopbarStore } from "@/stores/topbar";
import { useViewerStore } from "@/stores/viewer";

const KARAGANDA_REGIONS = [1, 2, 3, 4, 5, 6, 7, 9, 11, 15, 16, 17, 18, 19];

const viewerStore = useViewerStore();
const topbarStore = useTopbarStore();
const { t } = useI18n();

const regionIds = computed(() => {
  const ids = new Set();
  const selectedRegion = Number(viewerStore.selectedChild?.region_id || 0);
  const profileRegion = Number(viewerStore.profile?.region_id || 0);

  if (selectedRegion > 0) ids.add(selectedRegion);
  if (profileRegion > 0) ids.add(profileRegion);

  if (!ids.size) {
    viewerStore.children.forEach((child) => {
      const childRegion = Number(child?.region_id || 0);
      if (childRegion > 0) ids.add(childRegion);
    });
  }

  return [...ids];
});

const weatherQuery = useFeedWeatherQuery(regionIds);
const quizQuery = useFeedQuizListQuery();
const profiwayQuery = useFeedProfiwayListQuery();

const now = new Date();
const dateTo = now.toISOString().slice(0, 10);
const dateFrom = new Date(now.getTime() - 30 * 24 * 60 * 60 * 1000)
  .toISOString()
  .slice(0, 10);
const newsQuery = useFeedNewsListQuery(
  computed(() => ({
    sort: "-published_at",
    date_from: dateFrom,
    date_to: dateTo,
  }))
);

const weatherItem = computed(() => {
  const list = weatherQuery.data.value || [];
  return list[0] || null;
});

const quizItems = computed(() => {
  const roleId = Number(viewerStore.profile?.role_id || 0);
  return (quizQuery.data.value || [])
    .filter((item) => {
      const roles = item?.role_id;
      if (!Array.isArray(roles) || !roles.length || !roleId) return true;
      return roles.includes(roleId);
    })
    .map((item) => ({
      ...item,
      text: item?.text || item?.descripton || "",
    }));
});

const profiwayItems = computed(() => profiwayQuery.data.value || []);
const newsItems = computed(() => newsQuery.data.value || []);

const showHalykBanner = computed(() => {
  const regionId = Number(viewerStore.profile?.region_id || 0);
  return !regionId || KARAGANDA_REGIONS.includes(regionId);
});

onMounted(() => {
  topbarStore.setTitle(t("feed"));
});
</script>

<style scoped>
.feed-page {
  display: block;
  padding-inline: 24px;
}

.feed-section {
  margin-bottom: 16px;
}

.feed-news-grid {
  display: flex;
  flex-wrap: wrap;
  gap: 16px;
}

@media (max-width: 768px) {
  .feed-news-grid {
    display: block;
  }
  .feed-page {
    padding: 16px;
  }
}
</style>
